// extracted by mini-css-extract-plugin
module.exports = {"Container":"ScreenEffectText_Container__3xEM4","Original":"ScreenEffectText_Original__14ulw","Clone":"ScreenEffectText_Clone__T1m3z"};